import type { LandingPageContent } from '../types'

export const PLANIFICAR_INSTALACION_FOTOVOLTAICA: LandingPageContent = {
  slug: 'planificar-instalacion-fotovoltaica',
  lang: 'es',
  topicId: 'photovoltaik-planen',
  title: 'Planificar una instalación fotovoltaica – paso a paso',
  metaDescription:
    'Desde el análisis del tejado hasta la puesta en marcha: así planifica correctamente su ' +
    'instalación fotovoltaica - todos los pasos de un vistazo.',
  keywords: [
    'planificar instalación fotovoltaica',
    'cómo planificar placas solares',
    'pasos instalación fotovoltaica',
    'planificación fotovoltaica paso a paso',
    'fotovoltaica casa adosada',
  ],
  eyebrow: 'Guía de planificación',
  h1: 'Planificar una instalación fotovoltaica: el camino hacia su propia instalación solar',
  intro:
    'Desde el primer análisis del tejado hasta la instalación terminada hay varios pasos claros. Esta ' +
    'guía muestra todo el proceso de un vistazo - y enlaza en cada punto con las herramientas y ' +
    'páginas adecuadas de Roofora.',
  sections: [
    { type: 'heading', text: 'Paso 1: analizar el tejado y el consumo' },
    {
      type: 'paragraph',
      text:
        'La orientación e inclinación del tejado, la superficie disponible y su consumo anual ' +
        '(incluyendo bomba de calor o coche eléctrico, si los tiene) son la base de toda planificación. ' +
        'Suelen bastar unas fotos del tejado y del cuadro eléctrico hechas con el móvil.',
    },
    { type: 'heading', text: 'Paso 2: determinar el tamaño adecuado de la instalación' },
    {
      type: 'paragraph',
      text:
        'A partir de estos datos, Roofora calcula automáticamente una configuración de instalación ' +
        'adecuada - tamaño, potencia y si merece la pena una batería - directamente al crear su ' +
        'solicitud, sin necesidad de conocimientos técnicos ni herramientas adicionales.',
    },
    { type: 'heading', text: 'Paso 3: pedir y comparar presupuestos de empresas instaladoras' },
    {
      type: 'paragraph',
      text:
        'En lugar de llamar a empresas una por una, usted crea una solicitud anónima. Varias empresas ' +
        'instaladoras presentan presupuestos sin compromiso, que usted compara ordenados por precio.',
    },
    { type: 'heading', text: 'Paso 4: elegir empresa instaladora y autorizar el contacto' },
    {
      type: 'paragraph',
      text:
        'Usted revisa el perfil y el presupuesto de cada empresa interesada y decide individualmente a ' +
        'quién autoriza sus datos de contacto - sin autorización general para todas.',
    },
    { type: 'heading', text: 'Paso 5: instalación y puesta en marcha' },
    {
      type: 'paragraph',
      text:
        'La cita, el montaje y el alta de la instalación se gestionan directamente entre usted y la ' +
        'empresa elegida - sin más intermediación. Tras el montaje puede valorar a la empresa en ' +
        'Roofora.',
    },
  ],
  faq: [
    {
      q: '¿Cuánto tarda la planificación hasta el primer presupuesto?',
      a: 'La solicitud en sí se crea en pocos minutos. Después, las empresas instaladoras tienen entre 2 y 4 semanas para presentar un presupuesto.',
    },
    {
      q: '¿Necesito conocimientos previos para planificar una instalación?',
      a: 'No - la configuración adecuada se calcula automáticamente a partir de sus datos del tejado y de consumo.',
    },
    {
      q: '¿También funciona la planificación en una casa adosada con tejado limitado?',
      a: 'Sí - indique "casa adosada" como tipo de vivienda, las empresas instaladoras calculan su presupuesto directamente para la superficie de tejado realmente disponible, a menudo más estrecha.',
    },
  ],
  primaryCta: { label: 'Empezar la planificación ahora', action: 'customer' },
  secondaryCta: { label: '¿Cuánto cuesta una instalación fotovoltaica?', action: 'link', href: '/coste-instalacion-fotovoltaica' },
  relatedLinks: [
    { label: 'Coste de una instalación fotovoltaica', href: '/coste-instalacion-fotovoltaica' },
    { label: 'Cómo funciona la comparación de presupuestos', href: '/comparar-presupuestos-fotovoltaicos' },
    { label: 'Solicitar presupuesto fotovoltaico', href: '/solicitar-presupuesto-fotovoltaico' },
    { label: 'Encontrar instalador fotovoltaico', href: '/encontrar-instalador-fotovoltaico' },
    { label: '¿Solo necesita el montaje en el tejado?', href: '/montaje-paneles-solares' },
    { label: '¿Solo necesita la instalación eléctrica?', href: '/instalacion-electrica-fotovoltaica' },
    { label: '¿Cómo calcula Roofora el rendimiento según la orientación?', href: '/como-calculamos-el-precio' },
  ],
}
